const containerCls = "_n29c1tcuo9p";
const lineCls = "_n29l1ks83ii";

export { containerCls, lineCls };
import "./Line.style.linaria.module.css";
//# sourceMappingURL=Line.style.js.map
